import React from 'react';
import HrnbCard from '../controls/HrnbCard';
import HrnbButton from '../controls/HrnbButton';
import '../../css/news/NewsCard.css';
import {useNavigate} from "react-router-dom";

/**
 * Карточка новости
 */
export default function NewsCard({ news, className = "" }) {
    const navigate = useNavigate();
    
    if (!news) return null;

    const { id, title, date, preview } = news;

    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('ru-RU', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const handleReadMore = () => {
        // В будущем: переход на страницу новости
        console.log('Read more:', id);
    };

    return (
        <HrnbCard className={`news-card ${className}`}>
            <div className="news-card__content">
                <div className="news-card__header">
                    <h3 className="news-card__title">{title}</h3>
                    <span className="news-card__date">{formatDate(date)}</span>
                </div>
                
                {preview && (
                    <p className="news-card__preview">{preview}</p>
                )}
                
                <div className="news-card__actions">
                    <HrnbButton variant="primary" onClick={handleReadMore}>
                        Читать далее
                    </HrnbButton>
                </div>
            </div>
        </HrnbCard>
    );
}
